import axios from "../../axios/index.js"

export default {
  add(object) {
    return axios.post("panier",object, { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  get(id) {
    return axios.get("panier/"+id , { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
}